import { render, staticRenderFns } from "./ExitPopup.vue?vue&type=template&id=22c15036&scoped=true&"
import script from "./ExitPopup.vue?vue&type=script&lang=js&"
export * from "./ExitPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExitPopup.vue?vue&type=style&index=0&id=22c15036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c15036",
  null
  
)

export default component.exports